var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37 30h-2v-12a1 1 0 0 1 1-1h20v-9h2v10a1 1 0 0 1 -1 1h-20z",
    fill: "#cfd2d3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m57 4-3 6h6z",
    fill: "#41b737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.9 32a4.71 4.71 0 0 0 .1-1 5 5 0 0 0 -10 0 4.71 4.71 0 0 0 .1 1h-9.1v-28h28v9.1a4.71 4.71 0 0 0 -1-.1 5 5 0 0 0 0 10 4.71 4.71 0 0 0 1-.1v9.1z",
    fill: "#8c93ba"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m32 32h-9.1a4.71 4.71 0 0 0 .1-1 5 5 0 0 0 -10 0 4.71 4.71 0 0 0 .1 1h-9.1v28h28v-9.1a4.71 4.71 0 0 1 -1 .1 5 5 0 0 1 0-10 4.71 4.71 0 0 1 1 .1z",
    fill: "#f7c23c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m32 60h28v-28h-9.1a4.71 4.71 0 0 1 .1 1 5 5 0 0 1 -10 0 4.71 4.71 0 0 1 .1-1h-9.1v9.1a4.71 4.71 0 0 0 -1-.1 5 5 0 0 0 0 10 4.71 4.71 0 0 0 1-.1z",
    fill: "#f43b3b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bbbcbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37 9v2h-2v2h2v2h2v-2h2v-2h-2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 27v-2h2v-2h-2v-2h-2v2h-2v2h2v2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7899fc5b1e275e91ea9ec8b265ccaa0f.svg";
export { ForwardRef as ReactComponent };